ACC.addressvalidation = {

    _autoload: [
        ['start', document.querySelector('#addressForm')],
    ],

    start() {
        ACC.addressvalidation.validateZip();
        ACC.addressvalidation.changeSubmitButtonStatus();
        ACC.addressvalidation.calculateTaxForShippingAddress();
    },

    vertexRequiredFields: [
        '#address\\.townCity',
        '#address\\.region',
        '#address\\.postcode',
    ],

    shippingAddressRequiredFields: [
        '#address\\.firstName',
        '#address\\.surname',
        '#address\\.line1',
        '#address\\.postcode',
        '#address\\.townCity',
        '#address\\.region',
        '#address\\.phone',
    ],

    zipValidationCountryIso: [
        'US',
        'CA',
    ],

    isCheckoutZipChangeApplicableForFunction() {
        const selectedCountryValue = $('#address\\.country').val();
        return ACC.addressvalidation.zipValidationCountryIso.includes(selectedCountryValue)
            && ACC.utils.isHedTheme() && ACC.config.checkoutZipChangesEnabled;
    },

    calculateTaxForShippingAddress() {
        let timer;
        const waitTime = 1000;
        const selectedCountryCode = $('#address\\.country').val();
        ACC.addressvalidation.vertexRequiredFields.forEach((selector) => {
            $(document).on('input', selector, () => {
                if (ACC.addressvalidation.areVertexRequiredFieldsFilled('addressForm')
                    && ACC.addressvalidation.isCheckoutZipChangeApplicableForFunction()) {
                    ACC.buttonhelper.disable($('#addressSubmit'), ACC.config.calculatingTaxLabel);
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (ACC.validation.validateFormElement('addressForm', 'address\\.postcode')) {
                            // eslint-disable-next-line max-len
                            ACC.addressvalidation.validateShippingAddressAndCalculateTax($('#addressForm'), selectedCountryCode);
                        }
                    }, waitTime);
                }
            });
        });
    },

    validateShippingAddress(form) {
        const activeElementId = document.activeElement.id;
        $.ajax({
            type: 'POST',
            // eslint-disable-next-line max-len
            url: `${ACC.config.encodedContextPath}/checkout/multi/delivery-address/validate-shipping-address`,
            data: form,
            async: false,
            success(data) {
                // eslint-disable-next-line no-undef
                $('#i18nAddressForm').html(DOMPurify.sanitize(data));
                ACC.utils.preselectValue('#address\\.country');
                const addressCountry = $('#address\\.country');
                ACC.phonemasking.bind($('#address\\.phone'), addressCountry ? addressCountry.val() : null);
                ACC.utils.setFocusOnElementById(activeElementId);
            },
        }).done(() => {
            ACC.addressvalidation.changeSubmitButtonStatus();
        });
    },

    validateShippingAddressAndCalculateTax(addressForm) {
        let form = $(addressForm).serialize();
        if (!form.includes('&countryIso=')) {
            form = form.concat('&countryIso=', $('#address\\.country').val());
        }
        this.validateShippingAddress(form);
        if (ACC.validation.hasFormErrors('addressForm')) {
            return;
        }
        $.ajax({
            type: 'POST',
            // eslint-disable-next-line max-len
            url: `${ACC.config.encodedContextPath}/checkout/multi/delivery-address/validate-shipping-address-tax`,
            data: form,
            success(data) {
                // eslint-disable-next-line no-undef
                $('.subtotals').html($(DOMPurify.sanitize(data)).html());
            },
        }).done(() => {
            ACC.addressvalidation.changeSubmitButtonStatus();
        });
    },

    validateZip() {
        if (ACC.addressvalidation.isCheckoutZipChangeApplicableForFunction()) {
            $(document).on('input', '#address\\.postcode', () => {
                ACC.validation.validateFormElement('addressForm', 'address\\.postcode');
                ACC.addressvalidation.changeSubmitButtonStatus();
            });
        }
    },

    isZipValid(formId) {
        const validationResult = ACC.validation.validateFormElement(formId, 'address\\.postcode');
        if (!validationResult) {
            return false;
        }
        return true;
    },

    areVertexRequiredFieldsFilled(formId) {
        let areVertexFilled = true;
        ACC.addressvalidation.vertexRequiredFields.forEach((selector) => {
            if (!$(selector).val()) {
                areVertexFilled = false;
            }
        });
        if (areVertexFilled) {
            return ACC.addressvalidation.isZipValid(formId);
        }
        return false;
    },

    isAddressFormFilled(formId) {
        let areShippingAddressRequiredFieldsFilled = true;
        ACC.addressvalidation.shippingAddressRequiredFields.forEach((selector) => {
            if (!$(selector).val()) {
                areShippingAddressRequiredFieldsFilled = false;
            }
        });
        return areShippingAddressRequiredFieldsFilled && !ACC.validation.hasFormErrors(formId);
    },

    changeSubmitButtonStatus() {
        const submitButton = $('#addressSubmit');
        if (ACC.addressvalidation.isCheckoutZipChangeApplicableForFunction()) {
            if (!ACC.addressvalidation.isAddressFormFilled('addressForm')) {
                ACC.buttonhelper.disable(submitButton, ACC.config.deliveryAddressNextButton);
            } else {
                ACC.buttonhelper.enable(submitButton, ACC.config.deliveryAddressNextButton);
            }
        }
    },

    changeSubmitButtonRequiredFields() {
        if (ACC.addressvalidation.isCheckoutZipChangeApplicableForFunction()) {
            ACC.addressvalidation.shippingAddressRequiredFields.forEach((selector) => {
                $(document).on('input', selector, () => {
                    ACC.addressvalidation.changeSubmitButtonStatus();
                });
            });
        }
    },
};
